import logo from './logo.svg';
import './App.css';
import MyComponent from './BRL_CustomerPortal.jsx';

function App() {
  return (
    <div className="App">
      <MyComponent />   {/* ✅ ADD THIS LINE */}

      {/* Optional: remove default content */}
      {/* 
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header> 
      */}
    </div>
  );
}

export default App;